import React, { useContext } from "react";
import { RichText } from "../RichText";
import { QuestionContext } from "../../context";
import "./index.scss";

export function QuestionContent() {
    const ctx = useContext(QuestionContext);
    return <RichText className="QuestionContent">{ctx.data.content}</RichText>;
}
